import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface BasicFieldProps {
  name: string;
  value: any;
}

export function BasicField(props: BasicFieldProps) {
  if (props.value) {
    return (
      <>
        <dt className={DetailsTooltipStyles.DescriptionTerm}>{props.name}</dt>
        <dd className={DetailsTooltipStyles.DescriptionDetails}>{props.value}</dd>
      </>
    );
  } else {
    return null;
  }
}
